<template>
  <div class="track-waypoint" v-tooltip.bottom-center="wpHasAction">
    <!-- the drag handle -->
    <drag-handle class="drag-handle" @dragging="onDragging" @endDrag="onEndDrag">
    <i class="material-icons">arrow_drop_down</i>
    </drag-handle>
    <!-- the selectable point -->
    <div class="waypoint" @click.stop.prevent="selectWaypoint(wp)">
      {{ index + 1 }}
      <!--
      {{ Math.round(wp.time) }}
      -->
      </div>
  </div>
</template>

<script>
import { mapMutations } from 'vuex'
import TagHandle from './tagHandle.vue'

export default {
  name: 'track-waypoint',

  props: ['wp', 'index', 'hasAction', 'actionLabel'],

  components: {
    'drag-handle': TagHandle
  },

  computed: {
    wpHasAction() {
      return this.hasAction ? `has an action at the end: ${this.actionLabel}` : ''
    }
  },

  methods: {
    ...mapMutations(['selectWaypoint']),

    onClick(e) {
      this.selectWaypoint(this.wp)
    },

    onDragging(e) {
      this.$emit('moved', e)
    },

    onEndDrag(e) {
      this.$emit('stopMove', e)
    }
  }
}
</script>
